import { render, staticRenderFns } from "./JumpDeckOffTandemComponent.vue?vue&type=template&id=175cd6fb"
import script from "./JumpDeckOffTandemComponent.vue?vue&type=script&lang=js"
export * from "./JumpDeckOffTandemComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports